import { FormProvider as Form, UseFormReturn } from 'react-hook-form';
import { FormHTMLAttributes } from 'react';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
} & FormHTMLAttributes<HTMLFormElement>; // Include standard <form> props

export default function FormProvider({ children, onSubmit, methods, ...formProps }: Props) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} {...formProps}>
        {children}
      </form>
    </Form>
  );
}
